import { useMemo } from "react";
import "./Index.css";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJs, Tooltip, ArcElement } from "chart.js";
import { NO_RECORDS_ICON } from "../../../Constant";

ChartJs.register(ArcElement, Tooltip);

const PieChart = ({ dataset }) => {
  const generateRandomColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgb(${r}, ${g}, ${b})`;
  };
  const COLORS = [
    "rgb(255, 99, 132)", // Red
    "rgb(75, 192, 192)", // Teal
    "rgb(255, 205, 86)", // Yellow
    "rgb(201, 203, 207)", // Grey
    "rgb(54, 162, 235)", // Blue
    "rgb(153, 102, 255)", // Purple
    "rgb(255, 159, 64)", // Orange
    "rgb(100, 255, 218)", // Aqua
    "rgb(255, 99, 255)", // Pink
    "rgb(0, 200, 140)", // Green
  ];

  // GET COLOR BY ID
  const getColorById = (id) => {
    return COLORS[id % COLORS.length];
    return `rgb(${(id * 225) % 256}, ${(id * 167) % 256}, ${(id * 43) % 256})`;
  };

  const chartData = useMemo(() => {
    const data = [];
    const backgroundColor = [];
    const labels = [];
    if (dataset && dataset.length > 0) {
      dataset.forEach((item, index) => {
        data.push(item?.value);
        backgroundColor.push(getColorById(index)); // Use index, not id, to prevent out-of-bounds errors
        labels.push(item?.label || `Item ${index + 1}`); // You can customize this
      });
    }
    return { data, backgroundColor, labels };
  }, [dataset]);

  const data = {
    labels: chartData.labels,
    datasets: [
      {
        data: chartData.data,
        backgroundColor: chartData.backgroundColor,
      },
    ],
  };

  // To modify pie chart
  const options = {
    cutout: "70%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    elements: {
      arc: {
        borderWidth: 0,
      },
    },
  };
  return (
    <>
      {dataset && dataset.length > 0 ? (
        <>
          <Pie data={data} options={options} className="piechart" />
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              marginTop: "1rem",
              padding: "0.5rem 0",
              gap: "1rem",
              whiteSpace: "nowrap",
              maxWidth: "100%",
            }}
          >
            {chartData.labels.map((label, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0, // Prevents wrapping
                }}
              >
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: chartData.backgroundColor[index],
                    marginRight: 8,
                    borderRadius: "50%",
                  }}
                ></div>
                <span style={{ fontSize: 14 }}>{label}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="no_records">
            <img src={NO_RECORDS_ICON} className="mb-2" />
            <p>No records found !</p>
          </div>
        </>
      )}
    </>
  );
};
export default PieChart;
